import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";


const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // If we're on the collection page, push nav down further
  const menuTop = location.pathname === "/collection" ? "top-14" : "top-14";

  return (
    <header className="w-full bg-white shadow-md sticky top-0 z-[100]">
      <div className="max-w-screen-xl mx-auto flex justify-between items-center md:px-0 px-4 ">
        {/* Logo */}
        <img src="/logo.png" className=" h-16 w-auto   " alt="Logo" />

        {/* Desktop Nav */}
        <nav className="hidden md:flex gap-6 text-base text-gray-600">
          <Link to="/" className="hover:text-cyan-600">Home</Link>
          <Link to="/collection" className="hover:text-cyan-600">Collection</Link>
          <Link to="/catalogue" className="hover:text-cyan-600">Catalogue</Link>
      
          <Link to="/contact" className="hover:text-cyan-600">Contact</Link>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-gray-600"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {isOpen && (
        <div className={`absolute right-4 ${menuTop} w-56 bg-white shadow-lg rounded-lg p-4 z-[100]`}>
          <nav className="flex flex-col gap-4 text-gray-700 text-base">
            <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
            <Link to="/collection" onClick={() => setIsOpen(false)}>Collection</Link>
            <Link to="/catalogue" onClick={() => setIsOpen(false)}>Catalogue</Link>
           
            <Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
